import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Screenloader from "commons/components/ScreenLoader";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, authLoading } = useAuth();

  if (authLoading) return <Screenloader />;

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
